// @flow

import styled from "styled-components";

export const RunnerContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const RunnerNumberContainer = styled.div`
  min-width: 16px;
  height: 16px;
  margin-right: 8px;
`;
